import { useEffect } from "react";
import { noIntro, piKey, urlCampusKeys } from "./useURLParams.sideEffects.js";

import { nativeStorageInterface } from "../../index";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import Toast from "../../functions/classes/toast.class.js";
import StandardText from "../../components/elements/text/standardText.text.jsx";
import { urlParameters } from "./useURLParams.sideEffects.js";

export function useLoadServerData(props) {
  const intl = useIntl();
  const history = useHistory();

  const setAvailableCampuses = () => {
    if (piKey == null || props.serviceWorkerActive == null) return;
    // TODO: wtf???
    props.setAvailableCampus(piKey);
  };

  const loadCampusesAndData = () => {
    nativeStorageInterface.get("campusKeys").then((r) => {
      const campusKeys = r ?? [];
      if (!campusKeys || !campusKeys.length) return;
      // wenn alle campuskeys noch nicht da sind, warten
      if (!props.availableCampuses.length) return;

      /**
       * Ist dafür da dass unveröffentlichte daten geladen werden.
       * Welche Konsequenzen das haben wird: Keine Ahnung. Wenn es was umwirft:
       * Ich habe gesagt dass es mit einem URL Parameter besser wäre. Wenn es doch keine Probleme gibt,
       * wird dieser Kommentar höchstwahrscheinlich nicht gelesen...
       */
      // Da haben wir sie nun, die URL-Parameter.
      // Allerdings nur wenn wir in der Terminal-Version sind.
      // Und es ist auch nicht der URL-Parameter von CampusKeys,
      // sondern von ob wir ein Terminal sind.
      // Jetzt sollte jeder hier glücklich sein.
      const fetchedParams = new URLSearchParams(props.location.search);
      if (
        fetchedParams.get(urlParameters.isTerminal) === "true" &&
        fetchedParams.get(urlParameters.defaultStartNode) &&
        props.currentCampusKey != null
      ) {
        props.setCampusKeys([props.currentCampusKey]);
        props.loadCampuses(
          [props.currentCampusKey],
          props.language,
          props.settings?.routing?.userGroup
        );
      } else {
        props.setCampusKeys(campusKeys);
        props.loadCampuses(
          campusKeys,
          props.language,
          props.settings?.routing?.userGroup
        );
        return;
      }

      // wenn die infos da sind, vergleichen mit dem aus dem Cookie/URL gezogenen campuskey
      // wenn vorhanden in den campusKeys aus den piKey -> gut
      // wenn nicht, dann standardmäßig ersten aus den gegebenen wählen
      if (
        props.availableCampuses.find((ac) => ac.campusKey === campusKeys[0])
      ) {
        props.setCampusKeys(campusKeys);
        props.loadCampuses(
          campusKeys,
          props.language,
          props.settings?.routing?.userGroup
        );
      } else {
        const firstAvailableKey = [props.availableCampuses[0].campusKey];
        props.setCampusKeys(firstAvailableKey);
        props.loadCampuses(
          firstAvailableKey,
          props.language,
          props.settings?.routing?.userGroup
        );
      }
    });
  };

  const handleNoIntroCampusFetch = () => {
    if (!props.urlParametersReady) return;

    if (noIntro) {
      const userGroup = props.settings?.routing?.userGroup
        ? props.settings.routing.userGroup
        : "Error: useURLParams noIntro";

      if (!props.availableCampuses.length /*&& !urlCampusKeys?.length*/) {
        // scheinbar gibt es weder in der URL noch in den available
        fetch(`${process.env.REACT_APP_GET_CAMPUSES_URL}?piKey=${piKey}`)
          .then((res) => {
            const campuses = res.json();
            return campuses;
          })
          .then((json) => {
            let allCampusKeys = json.campuses.filter(
              (c) => c.published == null || c.published === true
            );

            let initCampusKeys = [];
            allCampusKeys = json.campuses.map((c) => {
              // check also if there are overlaps with the keys from the url
              if (urlCampusKeys && urlCampusKeys.length) {
                urlCampusKeys.forEach((urlKey) => {
                  if (urlKey === c.campusKey) {
                    initCampusKeys.push(c.campusKey);
                  }
                });
              }

              return c.campusKey;
            });
            if (initCampusKeys.length) {
              props.loadCampuses(initCampusKeys, null, userGroup);
            } else {
              props.loadCampuses(allCampusKeys, null, userGroup);
            }
          })
          .catch((e) => {
            throw e;
          });
      } else {
        props.loadCampuses(props.availableCampuses, null, userGroup);
      }
    }
  };

  const notifyAboutNewCampuses = () => {
    const fetchedParams = new URLSearchParams(props.location.search);
    if (
      fetchedParams.get(urlParameters.isTerminal) !== "true" &&
      props.newAvailableCampuses === true
    ) {
      const notificationElement = (
        <StandardText
          onClick={() => {
            history.push(`/settings`);
          }}
        >
          {intl.formatMessage({ id: "app.newCampusAvailable" })}
        </StandardText>
      );
      props.addToast(
        new Toast("id", notificationElement, Toast.toastTypes.info, [], 10000)
      );
    }
  };

  // Laden der Campusse und dann der ganzen Produktinstanzdaten für diese
  useEffect(loadCampusesAndData, [
    props.introComplete,
    props.availableCampuses,
    props.currentCampusId,
    props.currentCampusKey,
  ]);

  // GEOJSON Files (Die 3D Lagepläne) laden(falls vorhanden)
  // useEffect(loadGeoJSONs, [
  //   props.serverDataLoaded,
  //   props.currentCampusId,
  //   initialCampusKey,
  //   geoJSONtimeout,
  // ]);

  useEffect(setAvailableCampuses, [
    piKey,
    props.piKeyState,
    props.serviceWorkerActive,
  ]);

  useEffect(handleNoIntroCampusFetch, [props.urlParametersReady]);

  useEffect(() => {
    notifyAboutNewCampuses();
  }, [props.newAvailableCampuses, props.isTerminal]);
}
